import React, { useState, useCallback, useEffect, useRef } from 'react';
import classNames from 'classnames';
import '../../css/ViewTabs.css';

const ViewTabs = ({
    children,
    currentTab = '0',
    onTabChanged,
    light,
    className,
}) => {
    const tabSelectedHandlers = useRef(new Map());

    const onTabSelected = useCallback(
        (index) => {
            tabSelectedHandlers.current.forEach((handler) => handler(index));
            onTabChanged?.(index);
        },
        [onTabChanged]
    );

    const onTabReady = useCallback((index, handler) => {
        tabSelectedHandlers.current.set(index, handler);
    }, []);

    return (
        <section className={classNames('view-tabs', { light })}>
            <header className={className}>
                {React.Children.map(
                    children,
                    (child, index) =>
                        React.isValidElement(child) &&
                        React.cloneElement(child, {
                            onTabSelected,
                            onTabReady,
                            index: String(index),
                            isActive: currentTab === String(index),
                            key: index,
                            tabsNumber: children.length,
                        })
                )}
            </header>
            <section className="view-tabs-content">
                {children[currentTab]?.props.children}
            </section>
        </section>
    );
};

export default ViewTabs;
